import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { mediaQueriesList } from '../constants'

const SelectLayout = ({ layouts = {} }) => {
  const size = useSelector((state) => state.device.screenType)
  const renderedLayout = useMemo(() => {
    let layout = null

    // If we have the specified size, just use that
    if (layouts[size]) {
      layout = layouts[size]
    }

    const startIndex = mediaQueriesList.indexOf(size)
    // If we haven't found a layout
    // work backwards (to smaller sizes) from the current size
    // to the first matching size and use that
    if (!layout) {
      for (let i = startIndex; i >= 0; i -= 1) {
        if (layouts[mediaQueriesList[i]]) {
          layout = layouts[mediaQueriesList[i]]
          break
        }
      }
    }

    // If we haven't found a layout
    // work forwards (to larger sizes) from the current size
    // to the first matching size and use that
    if (!layout) {
      for (let i = startIndex + 1; i < mediaQueriesList.length; i += 1) {
        if (layouts[mediaQueriesList[i]]) {
          layout = layouts[mediaQueriesList[i]]
          break
        }
      }
    }

    // If the found layout is a function, run it to
    // render the actual layout
    // This makes sure we don't have to render all different
    // layouts and only render one
    if (typeof layout === 'function') {
      layout = layout()
    }
    return layout
  }, [size, layouts])

  return renderedLayout
}

SelectLayout.propTypes = {
  layouts: PropTypes.objectOf((_, key, componentName) => {
    if (!mediaQueriesList.includes(key)) {
      return new Error(
        `Invalid shape on layouts object supplied to \`${componentName}\`. Layout \`${key}\` does not exists.`,
      )
    }

    return null
  }),
}

export { SelectLayout as _SelectLayout }
export default SelectLayout
